export default function About() {
  return (
    <main>
<section className="sec tight">
    <div className="orb" style={{width: '500px', height: '500px', background: 'var(--accent)', top: '-200px', right: '-180px'}}></div>
    <div className="container">
      <p className="eyebrow">About</p>
      <h2 className="title">Lagos-based. <em>Global reach.</em></h2>
      <p className="sub">Five years across product design, UI/UX, brand and frontend. I design the thing and then build it, which removes a whole category of handoff loss — I know which interactions are cheap and which ones quietly cost a sprint.</p>
    </div>
  </section>
  <hr className="rule" />

  <section className="sec">
    <div className="container">
      <p className="eyebrow">Experience</p>
      <h2 className="title" style={{fontSize: 'clamp(1.9rem,3.6vw,2.8rem)', marginBottom: '2.4rem'}}>Five years, <em>two promotions</em></h2>
      <div className="tl">
        <div className="job" style={{ '--jc': 'var(--teal)' }}>
          <div className="when">Nov 2025 — May 2026</div>
          <h3>Lead Designer</h3>
          <div className="co">TavCorp · Lagos</div>
          <span className="tag-t tag">Joined as intern → promoted to lead</span>
          <ul>
            <li>Designed and shipped the TavCorp store: catalogue, cart, checkout and payment, live in production.</li>
            <li>Designed the customer dashboard, sign-in and every page of the company website.</li>
            <li>Led the design department — set direction, reviewed work and mentored designers.</li>
            <li>Built the Brisk Hauling &amp; Logistics brand identity end to end.</li>
          </ul>
        </div>
        <div className="job" style={{ '--jc': 'var(--teal)' }}>
          <div className="when">Sept 2024 — Jul 2025</div>
          <h3>Head of Product Design &amp; Template UI/UX</h3>
          <div className="co">SmartbloksAI · Lagos</div>
          <span className="tag-t tag">Joined as designer → promoted to head of two functions</span>
          <ul>
            <li>Designed the page-builder product: editor, widget library, live canvas and the settings system behind every widget.</li>
            <li>Built the control vocabulary that cut full-template build time from about six hours to under two.</li>
            <li>Designed Smartbillr, the company's AI invoicing product, across six screens.</li>
            <li>Designed 100+ templates across SaaS, e-commerce, health, real estate, hospitality and portfolio sectors.</li>
          </ul>
        </div>
        <div className="job">
          <div className="when">Jun 2023 — Sept 2024</div>
          <h3>Web &amp; UI Designer</h3>
          <div className="co">Ideastosite (ITS) · Lagos</div>
          <ul>
            <li>Produced roughly 85% of the studio's published design output — logos, brand identity, templates and social content.</li>
            <li>Designed and built client sites in Figma, then WordPress, Elementor and custom code.</li>
            <li>Designed and built teckafrica.org — fourteen pages for a children's tech-education charity.</li>
            <li>Delivered benoitlondon.com, cutesaint.com, tiagababy.com and americanelectrical.com.</li>
          </ul>
        </div>
        <div className="job">
          <div className="when">Aug — Sept 2024</div>
          <h3>Digital Technology Instructor</h3>
          <div className="co">Abridged Summer School · Lagos</div>
          <ul>
            <li>Taught HTML, CSS and JavaScript to children over a summer programme, each student shipping their own site.</li>
          </ul>
        </div>
        <div className="job">
          <div className="when">Apr 2022 — May 2023</div>
          <h3>Frontend Developer <span style={{color: 'var(--text-mute)', fontSize: '1rem'}}>(UI/UX focus)</span></h3>
          <div className="co">AltSchool Africa · Lagos</div>
          <ul>
            <li>Built and maintained React and Vue interfaces — responsive, accessible and cross-browser.</li>
            <li>Worked on performance, bug fixing and integrating components into larger systems.</li>
          </ul>
        </div>
        <div className="job">
          <div className="when">Sept 2021 — Mar 2022</div>
          <h3>Frontend Developer Intern</h3>
          <div className="co">HNG Internship · Lagos</div>
          <ul>
            <li>Rebuilt a Vue single-page application; the redesign contributed to a 40% increase in sign-ups.</li>
            <li>Documented style guidelines to keep the team's work consistent.</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <hr className="rule" />

  <section className="sec">
    <div className="container">
      <p className="eyebrow">Toolkit</p>
      <h2 className="title" style={{fontSize: 'clamp(1.9rem,3.6vw,2.8rem)', marginBottom: '2.2rem'}}>What I work <em>in</em></h2>
      <div className="cols3">
        <div className="panel">
          <h4>Design</h4>
          <div className="tags" style={{margin: 0}}>
            <span className="tag-g tag">Figma</span><span className="tag-g tag">Adobe XD</span><span className="tag-g tag">Design systems</span>
            <span className="tag-g tag">Wireframing</span><span className="tag-g tag">Prototyping</span><span className="tag-g tag">Usability testing</span>
            <span className="tag-g tag">Brand &amp; logo</span><span className="tag-g tag">Illustrator</span><span className="tag-g tag">Photoshop</span>
            <span className="tag-g tag">InDesign</span><span className="tag-g tag">Canva</span>
          </div>
        </div>
        <div className="panel">
          <h4>Build</h4>
          <div className="tags" style={{margin: 0}}>
            <span className="tag-g tag">React.js</span><span className="tag-g tag">Vue.js</span><span className="tag-g tag">JavaScript ES6+</span>
            <span className="tag-g tag">HTML5</span><span className="tag-g tag">CSS3</span><span className="tag-g tag">WordPress</span>
            <span className="tag-g tag">Elementor</span><span className="tag-g tag">WooCommerce</span><span className="tag-g tag">REST APIs</span>
            <span className="tag-g tag">Git</span><span className="tag-g tag">TypeScript (familiar)</span>
          </div>
        </div>
        <div className="panel">
          <h4>Also</h4>
          <div className="tags" style={{margin: '0 0 1.6rem'}}>
            <span className="tag-g tag">Technical writing</span><span className="tag-g tag">Developer handoff</span>
            <span className="tag-g tag">Mentoring</span><span className="tag-g tag">Teaching</span>
          </div>
          <h4>Recognition</h4>
          <div className="tags" style={{margin: 0}}>
            <span className="tag">1st place — Zaycodes WriteTech</span>
            <span className="tag-g tag">AltSchool Africa diploma, 2023</span>
          </div>
        </div>
      </div>
    </div>
  </section>
  <hr className="rule" />

  <section className="sec">
    <div className="container cols2" style={{alignItems: 'center'}}>
      <div>
        <p className="eyebrow">Off the clock</p>
        <h2 className="title" style={{fontSize: 'clamp(1.9rem,3.6vw,2.8rem)'}}>I also <em>play</em></h2>
        <p className="sub">I stream and post gameplay. Not a career in disguise — but it's where I learned to edit, to read a scoreboard at a glance, and why an interface that takes a second too long is an interface that loses.</p>
      </div>
      <div className="handles" style={{gridTemplateColumns: '1fr'}}>
        <a className="handle" href="https://www.youtube.com/@Afin-Gamer01/featured" target="_blank" rel="noopener noreferrer"><b>YouTube</b><span>@Afin-Gamer01 ↗</span></a>
        <a className="handle" href="https://www.tiktok.com/@afingamer01" target="_blank" rel="noopener noreferrer"><b>TikTok</b><span>@afingamer01 ↗</span></a>
        <a className="handle" href="https://medium.com/@johnsonzagazor06" target="_blank" rel="noopener noreferrer"><b>Medium</b><span>Technical writing ↗</span></a>
      </div>
    </div>
  </section>
    </main>
  );
}
